export default __webpack_public_path__ + "static/media/litho-demo-yoga-meditation.a8f7681b.jpg";